import type { InventorySystemProfileToVenueDTO, VenueDTO } from '../../../types'

export function filterUnlinkedVenues(
  venues: readonly VenueDTO[],
  mappings: readonly InventorySystemProfileToVenueDTO[]
): VenueDTO[] {
  const linkedVenueIds = new Set(mappings.map((mapping) => mapping.venueId))
  return venues.filter((venue) => !linkedVenueIds.has(venue.id))
}
